import {getMockupsStats} from "../../thunk";

const getID = (id) => {
    return `a${id}a`
}

export default {
    [getMockupsStats.pending as any]: (state) => {
        state.status = 'loading';
        state.error = null;
    },
    [getMockupsStats.fulfilled as any]: (state, action) => {
        state.status = 'resolved';
        state.data = action.payload;
        state.queryParams = {...action.meta.arg}
        },
    [getMockupsStats.rejected as any]: (state, action) => {
        state.status = 'rejected';
        state.error = action.payload;
    }
}
